module.exports = __webpack_public_path__ + "img/ET.14a0702b.png";